<template>
  <div>
    <DataTable
        :filters="filters"
        :loading="loading"
        :paginator="true"
        :resizableColumns="true"
        :rows="rows"
        :rowsPerPageOptions="[10, 25, 50, 100]"
        :scrollable="true"
        :selection.sync="selection"
        :value="dataRows"
        columnResizeMode="expand"
        selection-mode="multiple"
        style="height: 30px; max-width: 100% !important;"
    >
      <Column :header="translate('header.type')" :sortable="true" field="type"
              body-style="height: 30px"
      >
        <template #body="slotProps">
          <span v-html="renderType(slotProps.data.type)"></span>
        </template>
      </Column>
      <Column :header="translate('header.number')" :sortable="true" field="number"></Column>
      <Column :header="translate('header.client')" :sortable="true" field="client"></Column>
      <Column :header="translate('header.partner')" :sortable="true" field="partner"></Column>
      <Column :header="translate('header.State')" :sortable="true" field="state"></Column>
      <Column :header="translate('header.start')" field="start">
        <template #body="slotProps">
          {{ renderDateIntl(slotProps.data.start) }}
        </template>
      </Column>
      <Column :header="translate('header.end')" field="end">
        <template #body="slotProps">
          {{ renderDateIntl(slotProps.data.end) }}
        </template>
      </Column>
      <template #paginatorLeft>
        Count: {{ recordCount }}
      </template>
      <template #empty>
        {{ translate('no.records') }}
      </template>
    </DataTable>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import {renderContactType, renderDate} from './renderer';
import TranslateService from "../services/translate.service";

export default {
  name: "ContractGrid",
  props: ['dataRows', 'loading'],
  data() {
    return {
      filters: {},
      selection: [],
      rows: 10
    }
  },
  methods: {
    renderType(type) {
      return renderContactType(type);
    },
    translate(message) {
      return TranslateService.translateMessage(message);
    },
    renderDateIntl: renderDate
  },
  computed: {
    ...mapGetters('nav', ['getContentWidth']),
    recordCount() {
      return this.dataRows.length;
    },

  }
}
</script>

<style scoped>

</style>